import router from "~/common/router";
import RegistrationEmailsForm from "~/form/registration_emails_form";

router("users/registration_emails", ["new"], () => {
  RegistrationEmailsForm.start();
});
